export default __webpack_public_path__ + "static/media/Shopping history.56bd199f.svg";